import { type RequirementIdentifier, userApi, type UserProvidedValues } from '@capsicum/common';
import { type QueryKey, useMutation, useQuery } from '@tanstack/react-query';

export const useRequirementStateQuery = (
	key: QueryKey,
	requirementIdentifier: RequirementIdentifier,
	isEnabled = true
) => {
	return useQuery({
		enabled: isEnabled,
		queryFn: async () =>
			(await userApi).fetchUserUserRequirementStateUserMeRequirementIdentifierByRequirementIdentifier(
				requirementIdentifier
			),
		// eslint-disable-next-line @tanstack/query/exhaustive-deps
		queryKey: key,
		select: res => res.data
	});
};

export const useSetRequirementStateQuery = () => {
	return useMutation({
		mutationFn: async ({
			requirementIdentifier,
			state
		}: {
			requirementIdentifier: RequirementIdentifier;
			state: UserProvidedValues;
		}) =>
			(await userApi).putUserUserRequirementStateUserMeRequirementIdentifierByRequirementIdentifier(
				requirementIdentifier,
				state
			),
		mutationKey: ['put-requirement-state']
	});
};
